<div [innerHTML]="htmlContent | sanitizeHtml"></div>
